import * as React from 'react';
import './Spreadsheet.css';
import ProductModel from '../../domain/Product';

interface Props {
    product: ProductModel;
}

class SpreadsheetProduct extends React.PureComponent<Props> {
    public render(): JSX.Element {
        return (
            <div className="spreadsheet-table-row-product">
                <div className="product-image">
                    <img src={this.props.product.image} alt="product-image" />
                </div>
                <div className="product-name">
                    <span>{this.props.product.name}</span>
                </div>
                <div className="product-type">
                    <span>{this.props.product.season}</span>
                </div>
                <div className="product-package">
                    <span>{this.props.product.packageSize} pcs</span>
                </div>
                <div className="product-userPrice">
                    <span>{this.props.product.wholesalePrice}</span>
                </div>
                <div className="product-sku">
                    <div className="badge">{this.props.product.articleId}</div>
                </div>
            </div>
        );
    }
}

export default SpreadsheetProduct;



// WEBPACK FOOTER //
// ./src/view/order/SpreadsheetProduct.tsx